<script lang="ts" module>
  const circle = (cx: number, cy: number, r: number) =>
    `M${cx - r} ${cy}a${r} ${r} 0 1 0 ${r * 2} 0a${r} ${r} 0 1 0 ${-r * 2} 0`

  const rect = (x: number, y: number, w: number, h: number, r: number) =>
    `M${x + r} ${y}h${w - 2 * r}a${r} ${r} 0 0 1 ${r} ${r}v${h - 2 * r}a${r} ${r} 0 0 1 ${-r} ${r}` +
    `h${-(w - 2 * r)}a${r} ${r} 0 0 1 ${-r} ${-r}v${-(h - 2 * r)}a${r} ${r} 0 0 1 ${r} ${-r}z`

  // 24×24 stroke icons. Each entry is a list of path `d` attributes.
  const ICONS = {
    recipes: ['M5 4.5A1.5 1.5 0 0 1 6.5 3H19v16H6.5A1.5 1.5 0 0 0 5 20.5z', 'M5 20.5A1.5 1.5 0 0 0 6.5 22H19', 'M9 7.5h6', 'M9 11h4'],
    plan: [rect(3, 5, 18, 16, 2.5), 'M3 10h18', 'M8 3v4', 'M16 3v4', 'M7.5 14h2', 'M11 14h2', 'M14.5 14h2', 'M7.5 17.5h2'],
    shopping: ['M3 10h18l-1.6 8.4A2 2 0 0 1 17.4 20H6.6a2 2 0 0 1-2-1.6z', 'M8 10l3-6', 'M16 10l-3-6', 'M9 14v2.5', 'M12 14v2.5', 'M15 14v2.5'],
    pantry: [rect(7, 2.75, 10, 3.5, 1), 'M7.5 6.25h9A2.5 2.5 0 0 1 19 8.75v10A2.5 2.5 0 0 1 16.5 21.25h-9A2.5 2.5 0 0 1 5 18.75v-10a2.5 2.5 0 0 1 2.5-2.5z', 'M5 11h14', 'M5 16.5h14'],
    settings: ['M4 6h9', 'M19 6h1', circle(16, 6, 2.25), 'M4 12h3', 'M13 12h7', circle(10, 12, 2.25), 'M4 18h10', 'M20 18h0', circle(17, 18, 2.25)],
    sun: [circle(12, 12, 4), 'M12 2.5v2', 'M12 19.5v2', 'M2.5 12h2', 'M19.5 12h2', 'M5.3 5.3l1.4 1.4', 'M17.3 17.3l1.4 1.4', 'M5.3 18.7l1.4-1.4', 'M17.3 6.7l1.4-1.4'],
    moon: ['M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z'],
    system: [rect(3, 4, 18, 12, 2), 'M8 20h8', 'M12 16v4'],
    'log-out': ['M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3', 'M10 16.5L14.5 12 10 7.5', 'M14.5 12H4'],
    fork: ['M8 3v5.5a4 4 0 0 0 8 0V3', 'M12 3v5.5', 'M12 12.5V21'],
    check: ['M5 12.5l4.5 4.5L19 7.5'],
    close: ['M6 6l12 12', 'M18 6L6 18'],
    alert: [circle(12, 12, 9), 'M12 7.5v5.5', 'M12 16.5v.01'],
    plus: ['M12 5v14', 'M5 12h14'],
    minus: ['M5 12h14'],
    'cart-plus': ['M3 4h2l2.2 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L20.5 8H6', circle(9.5, 19.5, 1.25), circle(17, 19.5, 1.25), 'M13 9.5v4', 'M11 11.5h4'],
    search: [circle(11, 11, 6.5), 'M20 20l-4.2-4.2'],
    clock: [circle(12, 12, 9), 'M12 7v5l3 2'],
    users: [circle(9, 8, 3.5), 'M3 20a6 6 0 0 1 12 0', 'M16 4.5a3.5 3.5 0 0 1 0 7', 'M18 14.5a6 6 0 0 1 3 5.5'],
    grip: [circle(9, 6, 0.6), circle(15, 6, 0.6), circle(9, 12, 0.6), circle(15, 12, 0.6), circle(9, 18, 0.6), circle(15, 18, 0.6)],
    trash: ['M4 7h16', 'M10 11v6', 'M14 11v6', 'M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12', 'M9 7V4h6v3'],
    camera: ['M4 8a2 2 0 0 1 2-2h2l1.5-2h5L16 6h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z', circle(12, 13, 3.5)],
    edit: ['M4 20h4L19 9l-4-4L4 16z', 'M13.5 6.5l4 4'],
    'arrow-left': ['M19 12H5', 'M11 6l-6 6 6 6'],
    'arrow-right': ['M5 12h14', 'M13 6l6 6-6 6'],
    chevron: ['M9.5 5.5l6.5 6.5-6.5 6.5'],
    external: ['M14 4h6v6', 'M20 4l-9 9', 'M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4'],
    chef: ['M7 14a4 4 0 0 1-1-7.9A5 5 0 0 1 15.5 5 4 4 0 1 1 17 14', 'M7 14v6h10v-6', 'M7 17h10'],
    flip: ['M4 12a8 8 0 0 1 13.7-5.6L20 8.5', 'M20 4v4.5h-4.5', 'M20 12a8 8 0 0 1-13.7 5.6L4 15.5', 'M4 20v-4.5h4.5'],
    more: [circle(5.5, 12, 0.9), circle(12, 12, 0.9), circle(18.5, 12, 0.9)],
    // The meals: a cup of coffee, a bowl of noodles, a dinner dome, an apple.
    breakfast: ['M4 10h11.5v4.5a5 5 0 0 1-5 5h-1.5a5 5 0 0 1-5-5z', 'M15.5 11.5h1.25a2.5 2.5 0 0 1 0 5H15', 'M8 3.5c-.9 1.1.9 2.1 0 3.2', 'M11.5 3.5c-.9 1.1.9 2.1 0 3.2'],
    lunch: ['M3.5 12h17a8.5 8 0 0 1-17 0z', 'M9.5 20.5h5', 'M13 11.5l3.5-8', 'M15.5 11.5l4.5-6.5'],
    dinner: ['M4.5 16.5a7.5 7.5 0 0 1 15 0', 'M2.5 16.5h19', 'M4 20h16', 'M12 9V7.5', circle(12, 6.5, 1)],
    snack: [
      'M12 8c-1.6-1.2-7-1.5-7 4.2 0 4.3 2.8 8.3 4.8 8.3 1 0 1.4-.5 2.2-.5s1.2.5 2.2.5c2 0 4.8-4 4.8-8.3C19 6.5 13.6 6.8 12 8z',
      'M12 8V5.5',
      'M12 5.5c.6-1.6 2.2-2.4 3.8-2-.4 1.6-2 2.5-3.8 2z',
    ],
    link: ['M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1', 'M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1'],
    tag: ['M3.5 12.6V4.5a1 1 0 0 1 1-1h8.1a2 2 0 0 1 1.4.6l6.4 6.4a2 2 0 0 1 0 2.8l-7 7a2 2 0 0 1-2.8 0l-6.5-6.4a2 2 0 0 1-.6-1.3z', circle(8.5, 8.5, 1.25)],
    flame: ['M12 21a6.5 6.5 0 0 1-6.5-6.5c0-3.2 2.2-5.3 3.5-7.5.5 1.8 1.5 3 2.6 3.4C11.3 7 12.6 4.6 15 3c-.2 3 4 5.4 4 11.5A7 7 0 0 1 12 21z', 'M12 21a2.75 2.75 0 0 1-2.75-2.75c0-1.8 1.6-2.7 2.75-4.25 1.15 1.55 2.75 2.45 2.75 4.25A2.75 2.75 0 0 1 12 21z'],
    sparkle: ['M12 3v4', 'M12 17v4', 'M3 12h4', 'M17 12h4', 'M6 6l2.5 2.5', 'M15.5 15.5L18 18', 'M6 18l2.5-2.5', 'M15.5 8.5L18 6'],
  } as const

  export type IconName = keyof typeof ICONS
</script>

<script lang="ts">
  let { name, size = 20, strokeWidth = 1.75, class: className = '' }: {
    name: IconName
    size?: number
    strokeWidth?: number
    class?: string
  } = $props()
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width={strokeWidth}
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
  class={className}
>
  {#each ICONS[name] as d (d)}
    <path {d} />
  {/each}
</svg>
